<template>
  <div class="generic-page">
    <div class="banner" :style="bannerStyle">
      <div class="banner-content">
        <div class="subtitle">{{ subtitle }}</div>
        <h1 class="title">{{ title }}</h1>
      </div>
    </div>
    <section class="content-section">
      <!-- <v-btn
        @click="goBack"
        color="#BD9478"
        outlined
        rounded
        large
        class="back-button mt-6"
      > -->
      <div @click="$router.go(-1)" class="icon-wrapper">
        <div class="icon-bg" @click="goBack">
          <v-icon size="15" color="#BD9478" left>mdi-arrow-right</v-icon>
        </div>
        <span> חזרה </span>
      </div>
      <!-- </v-btn> -->
      <div v-html="content" class="content-wrapper"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: "GenericPage",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      required: true,
    },
    bannerImage: {
      type: String,
      default: "/default-banner.jpg",
    },
  },
  computed: {
    bannerStyle() {
      return {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${this.bannerImage})`,
      };
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.content-wrapper {
  line-height: 1.6;
  font-size: 16px;

  h1,
  h2,
  h3 {
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 16px;
  }
  li::marker {
    content: "." !important;
    font-size: 1.2em;
  }
}
</style>

<style scoped lang="scss">
.generic-page {
  direction: rtl;

  .banner {
    height: 300px;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding-right: 50px;

    .banner-content {
      color: white;

      .subtitle {
        font-size: 1.25rem;
        margin-bottom: 1rem;
        text-transform: uppercase;
        letter-spacing: 2px;
      }

      .title {
        font-size: 3rem;
        font-weight: bold;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
      }
    }
  }

  .content-section {
    padding-top: 35px;
    margin-bottom: 30px;
    margin-right: 50px;
    .icon-wrapper {
      margin-bottom: 20px;
      display: flex;
      gap: 10px;
      color: $primaryColor;
      .icon-bg {
        cursor: pointer;
        background: $litePrimaryColor;
        border-radius: 50%;
        padding: 1px 5px;
      }
    }
  }

  .back-button {
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(-5px);
    }
  }
}

.isMobile {
  .generic-page {
    .banner {
      height: 300px;

      .title {
        font-size: 2rem;
      }

      .subtitle {
        font-size: 1rem;
      }
    }

    .content-section {
      margin: 20px;
    }
  }
}
</style>